module.exports = __webpack_public_path__ + "assets/img/plus.f4aed6bd.svg";